import { makeCygnusApiCall } from 'api/api';

export const getHierarchy = async (returnId: any, clientMasterId: string | null | undefined): Promise<any[]> => {
  const hierarchy = await makeCygnusApiCall({
    type: 'GET',
    payload: {},
    url: `/client/hierarchy/${clientMasterId}/`,
    show_message: false,
    customized_success_message: 'Fetched Data Successfully',
    customized_failure_message: 'Unable to fetch data, please contact support and attach a screenshot.',
    isblob: false,
    path: '/tax',
    istax: true,
  });
  return hierarchy?.data ?? [];
};
